var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L12 85C12 86.1046 12.8954 87 14 87L81.3333 87L106 87C107.105 87 108 86.1046 108 85L108 16C108 14.8954 107.105 14 106 14L14 14C12.8954 14 12 14.8954 12 16Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 49L23 71C23 72.1046 23.8954 73 25 73L30.9444 73L32 73C33.1046 73 34 72.1046 34 71L34 49C34 47.8954 33.1046 47 32 47L25 47C23.8954 47 23 47.8954 23 49Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 39L44 71C44 72.1046 44.8954 73 46 73L51.9444 73L53 73C54.1046 73 55 72.1046 55 71L55 39C55 37.8954 54.1046 37 53 37L46 37C44.8954 37 44 37.8954 44 39Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44L65 71C65 72.1046 65.8954 73 67 73L72.9444 73L74 73C75.1046 73 76 72.1046 76 71L76 44C76 42.8954 75.1046 42 74 42L67 42C65.8954 42 65 42.8954 65 44Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56L65 70.9997C65 72.1043 65.8954 72.9997 67 72.9997L72.9444 72.9997L74 72.9997C75.1046 72.9997 76 72.1043 76 70.9997L76 59.9367C76 59.3432 75.7387 58.7817 75.2638 58.4257C73.7998 57.3281 70.3714 54.9755 66.9826 54.2309C65.9038 53.9939 65 54.8954 65 56Z",
    fill: "#A3C5FF",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55 56.6736L55 70.9997C55 72.1043 54.1046 72.9997 53 72.9997L47.0556 72.9997L46 72.9997C44.8954 72.9997 44 72.1043 44 70.9997L44 61.2732C44 60.7757 44.1833 60.2975 44.5402 59.9509C45.7686 58.7581 48.9689 55.9517 52.8636 54.8851C53.9921 54.576 55 55.5035 55 56.6736Z",
    fill: "#A3C5FF",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33L86 71C86 72.1046 86.8954 73 88 73L93.9444 73L95 73C96.1046 73 97 72.1046 97 71L97 33C97 31.8954 96.1046 31 95 31L88 31C86.8954 31 86 31.8954 86 33Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4111 97.6479L77.5731 104.953L83.4942 113.333",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6509,
    cy: 76.6532,
    r: 23.1978,
    transform: "rotate(178.086 60.6509 76.6532)",
    stroke: "#333333",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon-6.dbb1baa1.svg";
export { ForwardRef as ReactComponent };